export default {
    "page": {
      "account_exists": {
        "text": "It looks like you already have an account.",
        "button": "Continue to my account"
      },
      "existing_page": {
        "title": "Choose an existing company.",
        "button": "Continue with this company"
      }
    },
    "success": "You are now registered!"
};